import React, { useRef } from "react";
import { Button, Col, Row, Table, Typography } from "antd";
import { ArrowUpOutlined, DeleteOutlined } from "@ant-design/icons";
import Column from "antd/es/table/Column";

import { useReactToPrint } from "react-to-print";

const { Text } = Typography;

const TableEcriture = (props) => {
  const { readOnly, ecritureLignes, comptesGeneraux } = props;

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Row gutter={12}>
        <Col span={3} offset={21}>
          <Button type="primary" onClick={handlePrint} style={{ width: "100%" }}>
            Impression
          </Button>
        </Col>
      </Row>
      <div ref={componentRef}>
        <Table
          dataSource={ecritureLignes}
          className="table-ecritures"
          pagination={false}
          rowKey="cpt"
          loading={comptesGeneraux.length === 0}
          style={{ marginTop: 10 }}
          summary={(pageData) => {
            let totalDebit = 0;
            let totalCredit = 0;

            pageData.forEach(({ ecriture_ligne_montant_debit, ecriture_ligne_montant_credit }) => {
              totalDebit += parseFloat(ecriture_ligne_montant_debit);
              totalCredit += parseFloat(ecriture_ligne_montant_credit);
            });

            let background = "#ff7875";
            if (parseFloat(totalDebit).toFixed(2) === parseFloat(totalCredit).toFixed(2)) {
              background = "#b7eb8f";
            }

            return (
              <>
                <Table.Summary.Row style={{ background: background }}>
                  <Table.Summary.Cell>Total</Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>
                      <strong>
                        {parseFloat(totalDebit).toLocaleString("fr-FR", {
                          style: "currency",
                          currency: "EUR",
                        })}
                      </strong>
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>
                      <strong>
                        {parseFloat(totalCredit).toLocaleString("fr-FR", {
                          style: "currency",
                          currency: "EUR",
                        })}
                      </strong>
                    </Text>
                  </Table.Summary.Cell>
                  {!readOnly && <Table.Summary.Cell></Table.Summary.Cell>}
                  {!readOnly && <Table.Summary.Cell></Table.Summary.Cell>}
                </Table.Summary.Row>
                <Table.Summary.Row style={{ background: background }}>
                  <Table.Summary.Cell>Solde</Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>
                    <Text>
                      <strong>
                        {parseFloat(totalDebit - totalCredit).toLocaleString("fr-FR", {
                          style: "currency",
                          currency: "EUR",
                        })}
                      </strong>
                    </Text>
                  </Table.Summary.Cell>
                  {!readOnly && <Table.Summary.Cell></Table.Summary.Cell>}
                  {!readOnly && <Table.Summary.Cell></Table.Summary.Cell>}
                </Table.Summary.Row>
              </>
            );
          }}
        >
          <Column
            title="Compte Général"
            dataIndex="compte_general"
            key="compte_general"
            width="8%"
          />
          <Column
            title="Compte Auxiliaire"
            dataIndex="compte_auxiliaire"
            key="compte_auxiliaire"
            width="8%"
          />
          <Column
            title="Libellé compte"
            dataIndex="compte_libelle"
            key="compte_libelle"
            width="15%"
          />
          <Column
            title="Rubrique"
            dataIndex="ecriture_ligne_rubrique"
            key="ecriture_ligne_rubrique"
            width="10%"
          />
          <Column
            title="Libellé"
            dataIndex="ecriture_ligne_libelle"
            key="ecriture_ligne_libelle"
            width="25%"
          />
          <Column
            title="Montant Débit"
            dataIndex="ecriture_ligne_montant_debit"
            key="ecriture_ligne_montant_debit"
            width="10%"
          />
          <Column
            title="Montant Crédit"
            dataIndex="ecriture_ligne_montant_credit"
            key="ecriture_ligne_montant_credit"
            width="10%"
          />
          {!readOnly && (
            <Column
              title="Supprimer"
              dataIndex="cpt"
              key="cpt"
              width="7%"
              render={(cpt) => (
                <>
                  <Button
                    size="small"
                    icon={<DeleteOutlined />}
                    shape="circle"
                    style={{ width: 20, height: 20 }}
                    onClick={() => props.deleteEcritureLigne(cpt)}
                  />
                </>
              )}
            />
          )}
          {!readOnly && (
            <Column
              title="Modifier"
              dataIndex="cpt"
              key="cpt"
              width="7%"
              render={(text, record, index) => (
                <>
                  <Button
                    size="small"
                    icon={<ArrowUpOutlined />}
                    shape="circle"
                    style={{ width: 20, height: 20 }}
                    onClick={() => props.editEcritureLigne(record)}
                  />
                </>
              )}
            />
          )}
        </Table>
      </div>
    </>
  );
};

export default TableEcriture;
